import { GaranNestedLabelSvg } from 'components/Blocks/Product/Garan/Svg/GaranNestedLabelSvg';
import dynamic from 'next/dynamic';
import { useSessionStore } from 'store/useSessionStore';

const GaranFullLabelPopup = dynamic(
    () =>
        import('components/Blocks/Product/Garan/GaranFullLabelPopup').then(
            (component) => component.GaranFullLabelPopup,
        ),
    { ssr: false },
);

type GaranNestedLabelProps = {
    catalogNumber: string;
    warrantyYears: number;
};

export const GaranNestedLabel: FC<GaranNestedLabelProps> = ({ catalogNumber, warrantyYears }) => {
    const updatePortalContent = useSessionStore((s) => s.updatePortalContent);

    return (
        <button
            aria-label={`GARAN ${warrantyYears}`}
            className="relative block w-full max-w-[370px] cursor-pointer"
            type="button"
            onClick={() =>
                updatePortalContent(<GaranFullLabelPopup catalogNumber={catalogNumber} warrantyYears={warrantyYears} />)
            }
        >
            <GaranNestedLabelSvg aria-hidden className="h-auto w-full" warrantyYears={warrantyYears} />
        </button>
    );
};
